import "./RMStory.module.css";
import Header from "@/reusable_sections/Header";
import OurHeritageHospitality from "./sections/OurHeritageHospitality";
import ExploreByDiscipline from "./sections/ExploreByDiscipline";
import MeetYourAgents from "./sections/MeetYourAgents";
import Footer from "@/reusable_sections/Footer";
export default function RMStoryPage() {
  return <div>
      <Header />
      <OurHeritageHospitality />
      <ExploreByDiscipline />
      <MeetYourAgents />
      <Footer />
    </div>;
}